"use client";

import type * as React from "react";
import { useMemo } from "react";

import { GlobalSearchTrigger } from "@/components/global-search/global-search-trigger";
import { NavMain } from "@/components/nav-main";
import { ResetBookingDataSidebarButton } from "@/components/reset-booking-data-sidebar-button";
import { NavUser } from "./nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
import { useSelector } from "react-redux";
import { selectOrganization } from "@/store/modules/workspace/workspace.selectors";
import { useAccessOrEmpty } from "@/hooks/use-access";
import { useIsInsider } from "@/hooks/use-is-insider";
import { filterNavGroups } from "@/config/nav-config";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const organization = useSelector(selectOrganization);
  const { state } = useSidebar();
  const access = useAccessOrEmpty();
  const isInsider = useIsInsider();
  const navMain = useMemo(
    () => filterNavGroups(access, undefined, isInsider),
    [access, isInsider]
  );

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" className="w-full">
              <div className="flex items-center justify-center">
                {state === "expanded" ? (
                  <img
                    src={"/logo.png"}
                    alt={organization?.data.name}
                    style={{ maxHeight: 45, maxWidth: 200 }}
                  />
                ) : (
                  <img
                    src={"/logo-monogram.png"}
                    alt={organization?.data.name}
                    style={{ maxHeight: 32, maxWidth: 32 }}
                  />
                )}
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {state === "expanded" ? (
          <div className="mt-2 px-2 pb-2">
            <GlobalSearchTrigger />
          </div>
        ) : (
          <div className="mt-2 flex justify-center px-2 pb-2">
            <GlobalSearchTrigger compact />
          </div>
        )}
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        {/* <ResetBookingDataSidebarButton /> */}
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
